import type { LaborChartMetric } from '@/services/laborAnalytics'

export const WAGES_STATION_SALES_CAVEAT =
  'All stations involved in production of an item get full credit for sales from that item in figures in the chart; adding Sales figures across stations will overstate actual Sales.'

export type LaborChartCaptionMetric = Exclude<
  LaborChartMetric,
  'wages_pct_of_station_sales'
>

export type LaborChartCaptionMode = 'abs' | 'pct' | 'usd'

const GROSS_SALES_PER_HOUR_CAPTION =
  'How much the store sold for every hour someone worked. A higher number means you got more sales out of the same labor.'

const REGULAR_HOURS_ABS =
  'How many regular hours each station worked. This is the everyday schedule, not overtime.'

const REGULAR_HOURS_PCT =
  "Each station's slice of regular hours. Bigger slices mean that station used more of the schedule."

const OVERTIME_HOURS_ABS =
  'How much overtime each station worked. Big jumps often mean a station was short-staffed or extra busy.'

const OVERTIME_HOURS_PCT =
  "Each station's slice of overtime. Bigger slices mean that station accounted for more of the extra hours."

const WAGES_BY_STATION_USD =
  'How much we paid each station, including overtime. This is the labor bill by station.'

const WAGES_BY_STATION_PCT =
  "How much of that station's sales went to wages. A higher percent means labor ate more of what the station sold."

const AVG_HOURLY_WAGES_CAPTION =
  'The average amount paid per hour worked, including overtime. Rising lines mean the average rate is going up.'

const WAGES_PCT_OF_SALES_CAPTION =
  'How much of every sales dollar went to wages. A lower percent usually means labor cost is smaller relative to sales.'

export function laborChartCaption(
  metric: LaborChartCaptionMetric,
  mode?: LaborChartCaptionMode,
): string {
  switch (metric) {
    case 'gross_sales_per_hour':
      return GROSS_SALES_PER_HOUR_CAPTION
    case 'regular_hours_by_station':
      return mode === 'pct' ? REGULAR_HOURS_PCT : REGULAR_HOURS_ABS
    case 'overtime_hours_by_station':
      return mode === 'pct' ? OVERTIME_HOURS_PCT : OVERTIME_HOURS_ABS
    case 'wages_by_station':
      return mode === 'pct' ? WAGES_BY_STATION_PCT : WAGES_BY_STATION_USD
    case 'avg_hourly_wages':
      return AVG_HOURLY_WAGES_CAPTION
    case 'wages_pct_of_sales':
      return WAGES_PCT_OF_SALES_CAPTION
    default: {
      const _exhaustive: never = metric
      return _exhaustive
    }
  }
}
